import { translate } from "@kaltura/mediaspace-shared-utils";
import {
    TextField,
    RichtextField,
    PrivacySelectField,
    PrivacyType,
} from "@kaltura/mediaspace-shared-ui/controlled-form";
import React from "react";
import { SwitchesType } from "../types";
import Switches from "../switches/Switches";
import { useFormContext } from "react-hook-form";
import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";

export interface CreateCategoryFormProps {
    privacy: PrivacyType;
    switches?: SwitchesType[];
}

const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.danger.main,
    marginTop: theme.spacing(1),
}));

export function CreateCategoryForm(props: CreateCategoryFormProps) {
    const { privacy, switches } = props;
    const { formState } = useFormContext();
    const { errors } = formState;

    return (
        <form className={"kms-ds-create-channel-modal-content-form"}>
            <TextField
                label={translate("Name")}
                id={"name"}
                required={true}
                fontWeightBold={true}
                registerOptions={{
                    maxLength: {
                        value: 60,
                        message: translate("The name you entered exceeds the character limit (60 characters)"),
                    },
                }}
            />
            {errors.name && typeof errors.name.message === "string" && (
                <StyledTypography variant={"formError"} className="kms-ds-create-channel-modal-content-form-error">
                    {errors.name.message}
                </StyledTypography>
            )}
            <RichtextField label={translate("Description")} id={"description"} fontWeightBold={true} />
            <PrivacySelectField optionsData={privacy} />
            {switches && <Switches items={switches} />}
        </form>
    );
}

export default CreateCategoryForm;
